import React, { useEffect, useState } from "react";
import Fulfilment from './fulfilment'
import { IcontainerProps } from './fullfilmentinterface'
import helperfunctions from "../../../utils/helperfunctions";
import partsService from "../../../services/partsservice";
import { selectors as headerSelector } from '../../../state/features/header';
import { useSelector } from "react-redux";
import { ICartContextType } from "../../ShoppingCart/ShoppingCartPromo/shoppingcartpromointerface";
import { useCartContext } from "../../ShoppingCart/shoppingcart";
import { selectors as globalDataSelector } from "../../../state/features/common/globaldata";

const Fulfilmentcontainer = (props: IcontainerProps) => {
    const { stepperDetails, cartsDetails, isGuestUser }: ICartContextType = useCartContext();
    const [weatherWarning, setWeatherWarning] = useState<any>({ loading: false, data: {} });
    const initialDataList = { loading: false, data: [] };
    const initialLoadingDataList = { loading: true, data: [] };
    const [savedAddressList, setSavedAddressList] = useState<any>(initialDataList);
    const [savedAddressOptions, setSavedAddressOptions] = useState([]);
    const [fullfilmentBranchInfo, setFullfilmentBranchInfo] = useState({ loading: false, data: {} })
    const [isAvailabilityPopup, setIsAvailabilityPopup] = useState(false);

    const { globalData, headercurrentuser }: any = useSelector(
        state => ({
            globalData: globalDataSelector.globaldata(state),
            headercurrentuser: headerSelector.currentuser(state)
        })
    );

    useEffect(() => {
        getFullfilmentBranchInfo();
        if(!isGuestUser) {
            props?.getAvailabilityDetails()
        }
        getSavedAddressList();
    }, []);

    useEffect(() => {
        if (stepperDetails?.shipment?.countryCode && weatherWarning?.data && props?.updateStepperDetails) {
            props.updateStepperDetails({ ...stepperDetails, shipment: { ...stepperDetails?.shipment, weatherWarning: weatherWarning?.data?.weatherWarning } })
        }
    }, [weatherWarning]);

    const getSavedAddressList = async () => {
        try {
            setSavedAddressList(initialLoadingDataList);
            const reqBody = {
                orderId: 0,
                userAadId: headercurrentuser?.azureADId,
                customerId: globalData?.CustomerId ?? '',
                addressType: 0,
                isGuest: headercurrentuser?.isGuestUser
            }
            const response = await partsService.getSavedAddressList(reqBody);
            if (response?.isSuccess) {
                const addressList = response?.data?.addresses ?? [];
                setSavedAddressList({ loading: false, data: addressList });
                const displayNameList = addressList.map((item: any) => {
                    return {
                        value: item?.addressId,
                        title: item?.displayName,
                    };
                }) ?? [];
                setSavedAddressOptions(displayNameList);
                
            } else {
                setSavedAddressList(initialDataList);
                helperfunctions.showErrorMessage(`${response?.msg}`);
            }
        } catch (error) {
            setSavedAddressList(initialDataList);
            helperfunctions.showErrorMessage(`${error}`);
        }
    }

    const getWeatherWarning = async (zipcode: any = '', countryCode: any = '') => {
        try {
            if (zipcode.trim() && countryCode.trim()) {
                setWeatherWarning({ loading: true, data: {} });
                const response = await partsService.getWeatherWarning(cartsDetails?.cart?.cartId ?? 0, headercurrentuser?.azureADId, zipcode, countryCode);
                if (response?.isSuccess) {
                    setWeatherWarning({ loading: false, data: response?.data ?? {} });
                } else {
                    setWeatherWarning({ loading: false, data: {} });
                    helperfunctions.showErrorMessage(`${response?.msg}`);
                }
            } else {
                setWeatherWarning({ loading: false, data: {} });
            }
        } catch (error) {
            setWeatherWarning({ loading: false, data: {} });
            helperfunctions.showErrorMessage(`${error}`);
        }
    }

    const updateShipmentDetails = (data: any) => {
        if (props?.updateStepperDetails) {
            if (stepperDetails?.payment?.sameAsShipping) {
                props.updateStepperDetails({ ...stepperDetails, shipment: data, payment: { ...stepperDetails?.payment, ...data } });
            } else {
                props.updateStepperDetails({ ...stepperDetails, shipment: data });
            }
        }
    }

    const updateFulfillmentDetails = (data: any) => {
        if (props?.updateStepperDetails) {
            props.updateStepperDetails({ ...stepperDetails, fulfillment: data });
        }
    }

    useEffect(() => {
      let isNextDisable = true;
        const fulfillment = stepperDetails?.fulfillment;
        if (fulfillment?.isShipping || fulfillment?.isPickup || (fulfillment?.isPickupAvailable && fulfillment?.isPickupAvailablePlusShipping) || (fulfillment?.isPickupAvailable && fulfillment?.isPickupAvailablePlusAdditionalPickup) || (fulfillment?.isPickupWillCallKomatsuShipping)) {
            isNextDisable = false;
        }
      props?.getIsNextDisableStatus(isNextDisable);
    }, [stepperDetails?.fulfillment]);

    const onAvailableInfoClick = (data: any) => {
        props?.getAvailablePartsDetails(data);
    }

    const getFullfilmentBranchInfo = async () => {
        try {
            setFullfilmentBranchInfo({ loading: true, data: {} });
            const reqBody = {
                cartId: cartsDetails?.cart?.cartId ?? 0,
                userAadId: headercurrentuser?.azureADId ?? '',
            }
            const response = await partsService.getFullfilmentBranchInfo(reqBody);
            if (response?.isSuccess) {
                setFullfilmentBranchInfo({ loading: false, data: response?.data ?? {} });
            } else {
                setFullfilmentBranchInfo({
                    loading: false, data: {}
                });
                helperfunctions.showErrorMessage(`${response?.msg}`);
            }
        } catch (error) {
            setFullfilmentBranchInfo({
                loading: false, data: {}
            });
            helperfunctions.showErrorMessage(`${error}`);
        }
    };

    const onPickup = () => {
        let data = {
            isPickup: true,
            isShipping: false,
            isPickupAvailable: false,
            isPickupAvailablePlusShipping: false,
            isPickupAvailablePlusAdditionalPickup: false,
            isPickupWillCallKomatsuShipping : false,
        };
        updateFulfillmentDetails(data)
        props.saveFulfillmentType(data);
    }

    const onPickupAvailable = () => {
        let data = {
            isPickup: false,
            isShipping: false,
            isPickupAvailable: true,
            isPickupAvailablePlusShipping: false,
            isPickupAvailablePlusAdditionalPickup: false,
            isPickupWillCallKomatsuShipping: false,
        };
        updateFulfillmentDetails(data);
    }

    const onShipping = () => {
        let data = {
            isPickup: false,
            isShipping: true,
            isPickupAvailable: false,
            isPickupAvailablePlusShipping: false,
            isPickupAvailablePlusAdditionalPickup: false,
            isPickupWillCallKomatsuShipping: false,
        };
        updateFulfillmentDetails(data)
        props.saveFulfillmentType(data);
    }

    const onPickupAvailablePlusAdditionalPickup = () => {
        let data = {
            isPickup: false,
            isShipping: false,
            isPickupAvailable: true,
            isPickupAvailablePlusShipping: false,
            isPickupAvailablePlusAdditionalPickup: true,
            isPickupWillCallKomatsuShipping: false,
        };
        updateFulfillmentDetails(data)
        props.saveFulfillmentType(data);
    }

    const onPickupAvailablePlusShipping = () => {
        let data = {
            isPickup: false,
            isShipping: false,
            isPickupAvailable: true,
            isPickupAvailablePlusShipping: true,
            isPickupAvailablePlusAdditionalPickup: false,
            isPickupWillCallKomatsuShipping: false
        };
        updateFulfillmentDetails(data)
        props.saveFulfillmentType(data);
    }

    const onPickupWillCallKomatsuShipping = () => {
        let data = {
            isPickup: false,
            isShipping: false,
            isPickupAvailable: false,
            isPickupAvailablePlusShipping: false,
            isPickupAvailablePlusAdditionalPickup: false,
            isPickupWillCallKomatsuShipping: true,
        };
        updateFulfillmentDetails(data)
        props.saveFulfillmentType(data);
    }

    const onAvailablityPopup = () => {
        setIsAvailabilityPopup(!isAvailabilityPopup);
    }

    return (
        <Fulfilment
            getItemSummaryDetailsWithoutLoading={props?.getItemSummaryDetailsWithoutLoading}
            fulfillmentDetailRes={props?.fulfillmentDetailRes}
            availabilityDetails={props?.availabilityDetails}
            onAvailableInfoClick={onAvailableInfoClick}
            fullfilmentBranchInfo={fullfilmentBranchInfo}
            getDivRef={props?.getDivRef}
            onPickup={onPickup}
            onPickupAvailable={onPickupAvailable}
            onShipping={onShipping}
            isAvailabilityPopup={isAvailabilityPopup}
            onAvailablityPopup={onAvailablityPopup}
            onPickupAvailablePlusAdditionalPickup={onPickupAvailablePlusAdditionalPickup}
            onPickupAvailablePlusShipping={onPickupAvailablePlusShipping}
            onPickupWillCallKomatsuShipping={onPickupWillCallKomatsuShipping}
            phoneCodeOption={props?.phoneCodeOption}
            weatherWarning={weatherWarning}
            updateShipmentDetails={updateShipmentDetails}
            shipmentDetails={stepperDetails?.shipment}
            getWeatherWarning={getWeatherWarning}
            cartsDetails={cartsDetails}
            savedAddressOptions={savedAddressOptions}
            savedAddressList={savedAddressList}
            shoppingcartOnClick={props.shoppingcartOnClick}
            isNextClick={props?.isNextClick}
            baseRef={props?.baseRef}
        />
    )
}

export default Fulfilmentcontainer